import React from 'react';
import { Grid, CircularProgress, Stack } from '@mui/material';
import { useSelector } from 'react-redux';
import { PortalConfiguration, PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { PortalConfigurationRenderProps, PortalConfiguration as PortalConfigurationType_ } from '../../types';
import { usePortalConfiguration } from '../../api';
import { AiAssistantForm } from './AiAssistantForm';
import { AiAssistantConfig, AiAssistantFormValues } from '../types';

interface Props extends PortalConfigurationRenderProps {
  type: PortalConfigurationType;
}

export const AiAssistantManagement = ({ type, vendorProfile }: Props) => {
  const { isPortalConfigurationSaving, handleSaveConfiguration } = usePortalConfiguration();

  const portalConfig = useSelector((state: any) => portalConfigurationsSelectors.configDataByType(state, type)) as
    | PortalConfigurationType_<AiAssistantConfig>
    | undefined;

  const jsonConfig = portalConfig?.jsonDefinition?.config;

  const handleSave = async (formData: AiAssistantFormValues) => {
    const configToSave: PortalConfiguration = {
      ...portalConfig,
      vendorProfileId: vendorProfile.id,
      jsonDefinition: { config: formData },
    };
    await handleSaveConfiguration(configToSave);
  };

  return (
    <Grid item sm={12} md={6}>
      <CardContainer title="AI Assistant Management">
        <RenderWithFallback
          isLoading={!portalConfig}
          fallBack={
            <Stack alignItems="center" justifyContent="center" height="100%">
              <CircularProgress />
            </Stack>
          }
        >
          <AiAssistantForm isLoading={isPortalConfigurationSaving} defaultValues={jsonConfig!} onConfirm={handleSave} />
        </RenderWithFallback>
      </CardContainer>
    </Grid>
  );
};
